import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

export interface ConfirmMoveGroupCustomerData {
  groupName: string;
  deviceCount: number;
  currentCustomerName: string;
  newCustomerName: string;
}

@Component({
  selector: 'app-confirm-move-group-customer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-move-group-customer.component.html',
  styleUrl: './confirm-move-group-customer.component.scss',
})
export class ConfirmMoveGroupCustomerComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ConfirmMoveGroupCustomerData,
    private readonly dialogRef: MatDialogRef<ConfirmMoveGroupCustomerComponent>
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
